export enum Roles {
	Admin = "Administrador",
	MRM = "MRM",
	Client = "Cliente",
}
